<template>
  <div class="sectionBox">
    <img src="../../assets/portuguessBanner.jpeg" alt="">
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {}
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
img{
  margin: 0 auto;
  width: 6.4rem;
  display: block;
}
</style>
